import React, { useEffect, useState } from "react";
import ApiAmusementService from "../../../core/api/api.amusementService";
import ApiAmusementPackage from "../../../core/api/api.amusementPackage";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { Button, Col, Row, Spinner } from "react-bootstrap";
import SelectComponent from "../_Components/ReactSelectComponent";
import { TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/CloseRounded";
import SaveIcon from "@mui/icons-material/SaveRounded";
import { Link, useNavigate, useParams } from "react-router-dom";
import SwalMessage from "../_Components/SwalMessage";
import _ from "lodash";
import { tools } from "../../../core/utils/tools";
function AddEditPackageItems() {
  const [services, setServices] = useState([]);
  const [groupedReserveItemsOptions, setGroupedReserveItemsOptions] = useState([]);
  const [packageItemsList, setPackageItemsList] = useState([]);
  const [packageItemData, setPackageItemData] = useState(null);
  const [group, setGroup] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
  } = useForm();
  const navigate = useNavigate();

  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const { id } = useParams();

  useEffect(() => {
    (async () => {
      try {
        const amusementService = await ApiAmusementService.getAllServicesWithItems();
        setServices(amusementService);

        const packateItemData = await ApiAmusementPackage.getAmusementPackageById(id);
        if (!_.isEmpty(packateItemData)) {
          setPackageItemData(packateItemData);

          const parsedPackageItems = JSON.parse(packateItemData.amusementServicePackageItemsJson);
          if (_.isArray(parsedPackageItems)) {
            const formattedPackageItems = parsedPackageItems.map(i => ({ ...i, id: i.amusementServiceId }))
            const intersection = _.intersectionBy(amusementService, formattedPackageItems, "id")
            const finalArray = formattedPackageItems.map(item => {
              const foundAmusementService = intersection.find(i => i.id === item.amusementServiceId)
              if (foundAmusementService) {
                const foundReserveItem = foundAmusementService.amusementServiceReserveItems.find(i => i.id === +item.amusementServiceReserveItemId)
                const foundGroupItem = foundAmusementService.amusementServiceReserveItemGroups.find(i => i.id === +item.amusementServiceReserveItemGroupId)
                return {
                  ...item,
                  amusementServiceId: { value: item.amusementServiceId, label: foundAmusementService.name },
                  amusementServiceReserveItemId: { value: item.amusementServiceReserveItemId, label: foundReserveItem?.title },
                  amusementServiceReserveItemGroupId: { value: item.amusementServiceReserveItemGroupId, label: foundGroupItem?.title },
                  price: tools.formatPriceNumber(item.price)
                }
              } else {
                return item
              }
            })
            setPackageItemsList(finalArray);
          }
        }
      } catch (error) {
      }
    })();
  }, []);

  const handleChangeAmusementService = async (e, shouldRemoveGroupAndItem = false, item = null) => {
    if (e) {
      const value = e.value;
      const foundServiceId = services.find((item) => item.id === value);
      const reserveItems = foundServiceId?.amusementServiceReserveItems || [];
      const reserveItemGroups = foundServiceId?.amusementServiceReserveItemGroups || [];
      const convertedReserveItems = reserveItems.map((item) => ({ value: item.id, label: item.title }));
      const convertedReserveItemGroups = reserveItemGroups.map((item) => ({ value: item.id, label: item.title }));
      setGroupedReserveItemsOptions(convertedReserveItems);
      setGroup(convertedReserveItemGroups);
    }
    setValue("amusementServiceId", e);
    setValue(
      "amusementServiceReserveItemGroupId",
      shouldRemoveGroupAndItem ? item.amusementServiceReserveItemGroupId : undefined,
    );
    setValue(
      "amusementServiceReserveItemId",
      shouldRemoveGroupAndItem ? item.amusementServiceReserveItemId : undefined,
    );
  };

  const removeItemFromItemsList = (index) => {
    const originalArray = [...packageItemsList];
    originalArray.splice(index, 1); // remove the item with specified index
    setPackageItemsList([...originalArray]);
  };

  const handleEditItem = (item, index) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    handleChangeAmusementService(item.amusementServiceId, true, item);
    setValue("price", item.price);
    setValue("countPerReserve", item.countPerReserve);
    setValue("minimumCountPerReserve", item.minimumCountPerReserve);
    setValue("maximumCountPerReserve", item.maximumCountPerReserve);
    removeItemFromItemsList(index);
  };

  const handleAddItem = () => {
    const values = watch();
    let isAnySpecifiedItemsEmpty = false;
    // چک کردن اینکه آیتمی خالی نباشد
    Object.entries(values).map(([key, value]) => {
      if (
        ["amusementServiceId", "amusementServiceReserveItemGroupId", "amusementServiceReserveItemId"].includes(key) &&
        _.isEmpty(value)
      ) {
        isAnySpecifiedItemsEmpty = true;
      }
    });

    if (isAnySpecifiedItemsEmpty) {
      SwalMessage({
        title: "سرویس ، گروه آیتم یا آیتم های رزور نمیتواند خالی باشد",
        iSsuccess: false,
        timer: 4000,
      });
      return;
    }

    // چک کردن اینکه آیتمی تکراری نباشد
    const isAnyItemExistAlready = packageItemsList.find((item) => {
      const amusementServiceId = values.amusementServiceId?.value;
      const amusementServiceReserveItemGroupId = values.amusementServiceReserveItemGroupId?.value;
      const amusementServiceReserveItemId = values.amusementServiceReserveItemId?.value;
      if (
        item.amusementServiceId.value === amusementServiceId &&
        item.amusementServiceReserveItemGroupId.value === amusementServiceReserveItemGroupId &&
        item.amusementServiceReserveItemId.value === amusementServiceReserveItemId
      ) {
        return true;
      } else return false;
    });

    if (isAnyItemExistAlready !== undefined) {
      SwalMessage({
        title: "آیتمی با همین مشخصات در لیست وجود دارد",
        iSsuccess: false,
        timer: 4000,
      });
      return;
    }
    setPackageItemsList((prev) => [...prev, values]);
    reset()
  };

  const handleChangeRserveItems = (e) => {
    if (e) {
      const selectedReserveItemId = +e.value
      const selectedAmusementServiceId = +getValues("amusementServiceId")?.value
      const selectedAmusementService = services?.find(item => item.id === selectedAmusementServiceId)
      const reserveItems = selectedAmusementService ? selectedAmusementService.amusementServiceReserveItems : []
      if (reserveItems.length > 0) {
        const selectedReserveItem = reserveItems.find(item => item.id === selectedReserveItemId)
        // setValue("price", tools.formatPriceNumber(selectedReserveItem?.price)) // this should be uncommneted
        setValue("price", tools.formatPriceNumber((Math.random() * 10_000).toFixed())) // this one should be deleted
      }
    }
    setValue("amusementServiceReserveItemId", e)
  }

  const onSubmit = async () => {
    try {
      const convertArrayNumeric = packageItemsList.map((item) => ({
        ...item,
        amusementServiceId: item.amusementServiceId?.value,
        amusementServiceReserveItemGroupId: item.amusementServiceReserveItemGroupId?.value,
        amusementServiceReserveItemId: item.amusementServiceReserveItemId?.value,
        countPerReserve: +item.countPerReserve,
        maximumCountPerReserve: +item.maximumCountPerReserve,
        minimumCountPerReserve: +item.minimumCountPerReserve,
        price: +item.price.replaceAll(",", ""),
      }));
      const formattedJsonArray = JSON.stringify(convertArrayNumeric);
      const dataToSendServer = { amusementServicePackageItemsJson: formattedJsonArray, id: +id };
      const response = await ApiAmusementPackage.updateAmusementPackage(dataToSendServer);
      if (response.succeeded) {
        navigate("/amusementPackage");
      }
      SwalMessage({ title: response.message, iSsuccess: response.succeeded, timer: 5000 });
    } catch (error) {
    }
  };

  return (
    <>
      <div>
        <div className={`card card-custom`}>
          <div className="card-header border-0 pb-3 pt-5">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label font-weight-bolder text-dark">
                ایجاد / ویرایش آیتم برای پکیج {`${packageItemData?.title}`}
              </span>
              <span className="text-muted mt-3 font-weight-bold font-size-sm">
                برای ایجاد و یا ویرایش پکیج ، فرم زیر را تکمیل نمایید
              </span>
            </h3>
          </div>
          <div className="card-body pt-3 border-top">
            <FormProvider {...methods}>
              <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
                <Row>
                  <Col sm="6" xl="3" className="tb-reponsive  mb-4">
                    <Controller
                      name="amusementServiceId"
                      control={control}
                      render={({ field }) => (
                        <SelectComponent
                          className="mt-2"
                          placeholder="سرویس"
                          options={services?.map((item) => ({
                            value: item.id,
                            label: item.id + "-" + item.name,
                          }))}
                          field={field}
                          onChange={(e) => handleChangeAmusementService(e)}
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" xl="3" className="tb-reponsive  mb-4">
                    <Controller
                      name="amusementServiceReserveItemGroupId"
                      control={control}
                      render={({ field }) => (
                        <SelectComponent
                          className="mt-2"
                          placeholder="گروه آیتم"
                          options={group || []}
                          field={field}
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" xl="3" className="tb-reponsive   mb-4">
                    <Controller
                      name="amusementServiceReserveItemId"
                      control={control}
                      render={({ field }) => (
                        <SelectComponent
                          className="mt-2"
                          placeholder="آیتم های رزرو"
                          options={groupedReserveItemsOptions || []}
                          field={field}
                          onChange={handleChangeRserveItems}
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" xl="3" className="tb-reponsive  mb-4">
                    <Controller
                      name="price"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="مبلغ"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          className="mt-2"
                          onInput={(e) => {
                            const formattedPrice = tools.formatPriceNumber(e.target.value.replace(/[^0-9]/g, ""));
                            setValue("price", formattedPrice);
                          }}
                          value={value || ""}
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" xl="3" className="tb-reponsive   mb-4">
                    <Controller
                      name="countPerReserve"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="تعداد آیتم در پکیج"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          className="mt-2"
                          value={value || ""}
                          onInput={onChange}
                          type="number"
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" xl="3" className="tb-reponsive   mb-4">
                    <Controller
                      name="minimumCountPerReserve"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="حداقل تعداد آیتم در پکیج"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          className="mt-2"
                          value={value || ""}
                          onInput={onChange}
                          type="number"
                        />
                      )}
                    />
                  </Col>
                  <Col sm="6" xl="3" className="tb-reponsive   mb-4">
                    <Controller
                      name="maximumCountPerReserve"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="حداکثر تعداد آیتم در پکیج"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          className="mt-2"
                          value={value || ""}
                          onInput={onChange}
                          type="number"
                        />
                      )}
                    />
                  </Col>
                </Row>
                <Row className="pb-4">
                  <Col>
                    {/* <Button className="btn btn-light-primary"> */}
                    <Button
                      className="btn btn-light-primary"
                      onClick={() => {
                        handleAddItem();
                      }}
                    >
                      <i className="far fa-plus text-small pr-1"></i>
                      افزودن آیتم
                    </Button>
                    <Button
                      variant="light-danger"
                      type="button"
                      disabled={isSubmitting}
                      onClick={() => reset()}
                      className="ml-3"
                    >
                      <i className="fas fa-trash-alt text-small"></i>
                      پاک کردن فرم
                    </Button>
                    {/* </Button> */}
                  </Col>
                  {/* <Col>

                  </Col> */}
                </Row>

                <hr style={{ background: "black" }} className="my-5" />

                <div className="my-6">
                  {packageItemsList.length !== 0 && (
                    <div className="mb-5">
                      <h4 className=""> آیتم های اضافه شده</h4>
                      <div className="text-muted font-weight-bold font-size-sm">
                        می توانید آیتم های موجود در پکیج را ویرایش و یا حذف نمایید.
                      </div>
                    </div>
                  )}
                  {packageItemsList.length == 0 ? (
                    <h4 className="text-decoration-underline my-4 mb-6">آیتمی وجود ندارد</h4>
                  ) : (
                    packageItemsList.map((item, index) => {
                      return (
                        <div key={index} className="rounded-3 py-4 px-5 mt-3" style={{ border: "1px solid #ddd" }}>
                          <Row>
                            <Col xs="12" className="tb-reponsive px-2">
                              <div className=" px-2 fw-bold border-bottom mb-3 pb-3 rounded-2 text-secondary">
                                آیتم شماره {`${index + 1}`}{" "}
                              </div>
                            </Col>
                            <Col sm="6" xl="3" className="tb-reponsive  px-2 mb-4">
                              <SelectComponent
                                className="mt-2"
                                placeholder="سرویس"
                                value={item.amusementServiceId}
                                isDisabled
                              />
                            </Col>
                            <Col sm="6" xl="3" className="tb-reponsive  px-2 mb-4">
                              <SelectComponent
                                className="mt-2"
                                placeholder="گروه آیتم"
                                value={item.amusementServiceReserveItemGroupId}
                                isDisabled
                              />
                            </Col>
                            <Col sm="6" xl="3" className="tb-reponsive  px-2 mb-4">
                              <SelectComponent
                                className="mt-2"
                                placeholder="آیتم های رزرو"
                                value={item.amusementServiceReserveItemId}
                                isDisabled
                              />
                            </Col>
                            <Col sm="6" xl="3" className="tb-reponsive  px-2 mb-4">
                              <TextField
                                label="مبلغ"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                className="mt-2"
                                value={item.price}
                                disabled
                              />
                            </Col>

                            <Col sm="6" xl="3" className="tb-reponsive  px-2 mb-4">
                              <TextField
                                label="تعداد آیتم در پکیج"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                className="mt-2"
                                value={item.countPerReserve}
                                type="number"
                                disabled
                              />
                            </Col>
                            <Col sm="6" xl="3" className="tb-reponsive  px-2 mb-4">
                              <TextField
                                label="حداقل تعداد آیتم در پکیج"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                className="mt-2"
                                value={item.minimumCountPerReserve}
                                type="number"
                                disabled
                              />
                            </Col>
                            <Col sm="6" xl="3" className="tb-reponsive  px-2 mb-4">
                              <TextField
                                label="حداکثر تعداد آیتم در پکیج"
                                margin="normal"
                                variant="outlined"
                                size="small"
                                className="mt-2"
                                value={item.maximumCountPerReserve}
                                type="number"
                                disabled
                              />
                            </Col>
                          </Row>
                          <Row>
                            <Col className="d-flex gap-2 border-top mt-3 pt-3">
                              <Button
                                variant="light-primary"
                                className="btn-icon"
                                onClick={() => {
                                  handleEditItem(item, index);
                                }}
                              >
                                <i className="far fa-edit text-small"></i>
                              </Button>
                              <Button
                                variant="light-danger"
                                className="btn-icon"
                                onClick={() => {
                                  removeItemFromItemsList(index);
                                }}
                              >
                                <i className="far fa-trash-alt  text-small"></i>
                              </Button>
                            </Col>
                          </Row>
                        </div>
                      );
                    })
                  )}
                </div>

                <Row className="mt-5">
                  <div>
                    <Button variant="success" type="submit" disabled={isSubmitting}>
                      {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                      <SaveIcon /> ذخیره
                    </Button>
                    <Link className="btn btn-danger ml-3" to="/amusementPackage">
                      <CloseIcon /> بازگشت
                    </Link>
                  </div>
                </Row>
              </form>
            </FormProvider>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddEditPackageItems;
